//
// locale_fi.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/fi.json';
import localeData from "react-intl/locale-data/fi.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_fi.js